<main class="container-fluid">
  <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
    <div class="col-12 col-md-3 p-3 my-md-3" id="buscador">
      <h5 class="text-center">Consulta de sanciones</h5>
      <form [formGroup]="form" (ngSubmit)="getInfo()">
        <div class="form-group">
          <label class="small text-secondary" for="numero_identificacion"
            >Ingrese el número de identificacion</label
          >
          <input
            type="text"
            formControlName="numero_identificacion"
            class="form-control form-control-sm"
          />
        </div>
        <div class="text-center">
          <button
            class="btn btn-primary mt-3 mb-1"
            [disabled]="form.invalid"
            type="submit"
          >
            Buscar
          </button>
        </div>
      </form>
      <div *ngIf="isSubmitted && (datosPersona == null || datosPersona.ingreso_manual == true)">
        <header class="mb-3 mt-2">
          <h5 class="text-center">Agregar Persona</h5>
        </header>
        <form [formGroup]="createForm" (ngSubmit)="createPersona()">
          <div class="form-group">
            <label class="small text-secondary" for="nombre">Nombres</label>
            <input
              id="nombre"
              formControlName="nombre"
              type="text"
              class="form-control form-control-sm"
            />
          </div>
          <div class="form-group">
            <label class="small text-secondary" for="numero_identificacion">Número identificación</label>
            <input
              id="numero_identificacion"
              formControlName="numero_identificacion"
              type="text"
              class="form-control form-control-sm"
            />
          </div>
          <div class="form-group">
            <label class="small text-secondary" for="codigo_departamento">Departamento</label>
            <select
              class="form-control form-control-sm"
              id="codigo_departamento"
              formControlName="codigo_departamento"
              (change)="onMunicipio()"
            >
              <ng-container *ngFor="let item of departamentos">
                <option [ngValue]="item.departamento_id">
                  {{ item.descripcion }}
                </option>
              </ng-container>
            </select>
          </div>
          <div class="form-group">
            <label class="small text-secondary" for="codigo_municipio">Municipio</label>
            <select
              class="form-control form-control-sm"
              id="codigo_municipio"
              formControlName="codigo_municipio"
            >
              <ng-container *ngFor="let item of municipios">
                <option [ngValue]="item.municipio_id">
                  {{ item.descripcion }}
                </option>
              </ng-container>
            </select>
          </div>
          <div class="form-group">
            <label class="small text-secondary" for="direccion">Dirección</label>
            <input
              id="direccion"
              formControlName="direccion"
              type="text"
              class="form-control form-control-sm"
            />
          </div>
          <div class="form-group">
            <label class="small text-secondary" for="numero_telefonico">Teléfono</label>
            <input
              id="numero_telefonico"
              formControlName="numero_telefonico"
              type="text"
              class="form-control form-control-sm"
            />
          </div>
          <div class="form-group">
            <label class="small text-secondary" for="correo">Correo electrónico</label>
            <input
              id="correo"
              formControlName="correo"
              type="text"
              class="form-control form-control-sm"
            />
          </div>
          <div class="form-group">
            <label class="small text-secondary" for="correo_fiscal">Correo electrónico fiscal</label>
            <input
              id="correo_fiscal"
              formControlName="correo_fiscal"
              type="text"
              class="form-control form-control-sm"
            />
          </div>
          <div class="form-row mt-5">
            <button
              class="btn btn-outline-primary m-auto"
              (click)="resetCreateForm()"
              type="button">
              Limpiar
            </button>
            <button
              class="btn btn-primary m-auto"
              [disabled]="!createForm.valid"
              type="submit">
              Agregar
            </button>
          </div>
        </form>
      </div>
    </div>
    <div class="col-12 col-md-9 my-3" *ngIf="datosPersona && datosPersona.persona_id; else no_data">
      <div class="row mb-3 fs-5" id="colorDiv">
        <div class="col-12">
          <div class="row justify-content-start">
            <div class="col-md-3 mb-3">
              <label>Nombre y Apellidos</label>
              <p>{{ datosPersona.nombre }}</p>
            </div>
            <div class="col-md-2 mb-3">
              <label>Número de identificación</label>
              <p>{{ datosPersona.numero_identificacion }}</p>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row justify-content-start">
            <div class="col-md-3 mb-3">
              <label>Departamento</label>
              <p>{{ datosPersona.desc_departamento }}</p>
            </div>
            <div class="col-md-2 mb-3">
              <label>Municipio</label>
              <p>{{ datosPersona.desc_municipio }}</p>
            </div>
            <div class="col-md-2 mb-3">
              <label>Dirección</label>
              <p>{{ datosPersona.direccion }}</p>
            </div>
            <div class="col-md-2 mb-3">
              <label>Número de celular</label>
              <p>{{ datosPersona.numero_telefonico }}</p>
            </div>
            <div class="col-md-2 mb-3">
              <label>Correo electrónico</label>
              <p>{{ datosPersona.correo }}</p>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row justify-content-start">
            <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
              <label>Correo electrónico fiscal</label>
              <p>{{ datosPersona.correo_fiscal }}</p>
            </div>
          </div>
        </div>
        <div class="col-12 mb-3">
          <button class="btn btn-primary float-right"
                  [disabled]="datosPersona.persona_id == null"
                  (click)="redirectTo()">Asignar sancion</button>
        </div>
      </div>
      <form [formGroup]="filtro">  
      <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="small text-secondary" for="numero_resolucion">Número resolución</label>
              <input
                id="numero_resolucion"
                formControlName="numero_resolucion"
                type="text"
                class="form-control form-control-sm"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="small text-secondary" for="fecha_exp_acto_admin">Fecha expedición del acto administrativo</label>
              <input
                id="fecha_exp_acto_admin"
                formControlName="fecha_exp_acto_admin"
                type="date"
                class="form-control form-control-sm"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="small text-secondary" for="numero_rnt">Número RNT</label>
              <input
                id="numero_rnt"
                formControlName="numero_rnt"
                type="text"
                class="form-control form-control-sm"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="small text-secondary" for="sancion_estado_id">Estado sanción</label>
              <select
                class="form-control form-control-sm"
                id="sancion_estado_id"
                formControlName="sancion_estado_id"
              >
                <ng-container *ngFor="let item of estados_sanciones">
                  <option [ngValue]="item.sancion_estado_id">
                    {{ item.desc_sancion_estado }}
                  </option>
                </ng-container>
              </select>
            </div>
          </div>
          <div class="col-md-12 mb-3">
          
          <button class="btn btn-primary float-right m-2" (click)="filtrar()">Filtrar</button>
          <button class="btn btn-outline-primary float-right m-2" (click)="clearFiltro()">Limpiar Filtro</button>
          </div>
        </div>
      </form>
      <div class="row" *ngIf="sancionesPersona?.length > 0; else no_sanciones">
        <div class="col-12">
          <h6 class="font-weight-bold mb-3">Sanciones actuales</h6>
        </div>
        <div class="col-12">
          <div class="table-responsive">
            <app-tablas 
                      [page]="paginaActual"
                      [headers]="headerTabla" 
                      [sizeData]="sancionesPersona.length"
                      (paginado)="onPaginado($event)"
                      class="table-responsive">
                            <tr *ngFor="let item of sancionesPersona; let i = index" class="small">
                                <td>{{ item.numero_resolucion }}</td>
                                <td>{{ item.fecha_creacion | date: 'dd-MM-yyyy'}}</td>
                                <td>{{ item.fecha_exp_acto_admin | date: 'dd-MM-yyyy'}}</td>
                                <td>{{ item.fecha_eje_acto_admin | date: 'dd-MM-yyyy'}}</td>
                                <td>{{ item.desc_decreto_1836 }}</td>
                                <td>{{ item.codigos_rnt }}</td>
                                <td>{{ item.desc_sancion_estado }}</td>
                                <td>
                                  <a href="javascript:void(0)" (click)="onViewHistorial(item)">
                                    <img src="assets/icons/EYE.png" width="25">
                                  </a>
                                </td>
                                <td>
                                  <ng-template #popContent>
                                    <ng-container *ngIf="item.sancion_estado_id == id_activo">
                                      <ng-container *ngFor="let accionRnt of accionesActivo">
                                        <button
                                          class="btn btn-outline-light border-0 text-left w-100"
                                          (click)="onAcciones(item, accionRnt)"
                                        >
                                          {{ accionRnt.descripcion }}
                                        </button>
                                      </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="item.sancion_estado_id == id_inactivo " >
                                      <ng-container *ngFor="let accionRnt of accionesInactivo">
                                        <button
                                          class="btn btn-outline-light border-0 text-left w-100"
                                          (click)="onAcciones(item, accionRnt)"
                                        >
                                          {{ accionRnt.descripcion }}
                                        </button>
                                      </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="item.sancion_estado_id == id_eliminado " >
                                      <ng-container *ngFor="let accionRnt of accionesEliminado">
                                        <button
                                          class="btn btn-outline-light border-0 text-left w-100"
                                          (click)="onAcciones(item, accionRnt)"
                                        >
                                          {{ accionRnt.descripcion }}
                                        </button>
                                      </ng-container>
                                    </ng-container>
                                  </ng-template>
                                  <button
                                    type="button"
                                    class="btn btn-outline-secondary text-center"
                                    placement="bottom"
                                    [ngbPopover]="popContent"
                                    popoverClass="bg-dark"
                                    >
                                    ..
                                  </button>
                                </td>
                            </tr>
            </app-tablas>
          </div>
        </div>
      </div>
      <ng-template #no_sanciones>
        <h4 class="font-weight-bold">No tiene sanciones actuales</h4>
      </ng-template>
    </div>
    <ng-template #no_data>
      <div class="col-12 col-md-9 align-self-center text-center my-5">
        <img
          class="img-fluid px-5"
          src="../../../../../../../assets/images/sin_establecimiento.png"
        />
        <h3>No hay información</h3>
      </div>
    </ng-template>
  </article>
</main>
